var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-descriptions',{attrs:{"title":"配置信息","column":2}},[_c('a-descriptions-item',{attrs:{"label":"eSIM供应商"}},[_vm._v(" "+_vm._s(_vm.data.esim_supplier_name)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }